import { FunctionComponent } from "react";
import ProspectEmbed from "rivals/components/pages/ProspectProfile/ProspectEmbed";
import Modal from "rivals/components/shared/Modal";
import { Z_INDICES } from "rivals/shared/constants";
import styles from "./EmbedProspectModal.module.scss";
import type { OwnProps } from "./types";

const EmbedProspectModal: FunctionComponent<OwnProps> = ({
  activeAthleteView,
  closeModal,
  prospect,
  showModal
}) => {
  return (
    <Modal
      handleCancel={closeModal}
      handleConfirm={closeModal}
      hasCloseIcon
      open={showModal}
      showFooter={false}
      wrapClassName={styles.modalWrapper}
      zIndex={Z_INDICES["embed-athlete-modal-z-index"]}
    >
      <ProspectEmbed
        activeAthleteView={activeAthleteView}
        prospect={prospect}
      />
    </Modal>
  );
};

export default EmbedProspectModal;
